<fin-pax-ancillary-product
  *ngIf="(safService$ | async) && (cartOrOrder$ | async) as cartOrOrder"
  [translations]="serviceCatalogWithSelection?.translations"
  [loadingTitle]="'localSettings.ancillaries.cover.loadingTitle' | finLocalization"
  [customProductTitle]="'ancillaries.saf.productTitle' | finLocalization"
  [actionTextSubTitle]="'ancillaries.saf.productSubTitle' | finLocalization"
  [categoryWithSelections$]="safServicesWithSelection$"
  [category]="serviceCatalogWithSelection?.category"
  [servicesReady$]="servicesReady$"
  [price$]="totalPrice$"
  [analyticsContext]="'booking-flow_review-page'"
  (selectionChanged)="updateSelectionsForFragment($event)"
  [attr.data-testid]="'pax-ancillary-' + serviceCatalogWithSelection?.category"
  [showInfoButton]="false"
  [icon]="SvgLibraryIcon.SAF"
  [isLoading$]="safIsLoading$"
>
  <div *ngIf="safModalFragment$ | async" class="nordic-blue-50-bg nordic-blue-900-text ps-xsmall-y ps-medium-x">
    <fcom-link (afterNavigation)="openModal = true" data-testid="impact-saf-link">
      {{ 'ancillaries.saf.contributionLinkText' | finLocalization }}
    </fcom-link>
  </div>
</fin-pax-ancillary-product>

<fcom-modal
  *ngIf="safModalFragment$ | async as fragment"
  [(open)]="openModal"
  [buttons]="ModalButtons.CLOSE"
  [title]="fragment.teaserTitle"
>
  <fcom-image *ngIf="fragment.picture" [imageData]="fragment.picture" [ratio]="'21x9'"></fcom-image>
  <div class="pr-medium">
    <h3
      *ngIf="isSafSelected$ | async"
      class="font-heading-4 ms-large-b ps-large-b border-bottom"
      data-testid="impact-saf-thank-you"
    >
      {{ 'ancillaries.saf.contributionThankYouTitle' | finLocalization }}
    </h3>

    <h3
      *ngIf="(isSafSelected$ | async) === false"
      class="font-heading-4 ms-large-b ps-large-b border-bottom"
      data-testid="impact-saf-join-us"
    >
      {{ 'ancillaries.saf.contributionJoinUsTitle' | finLocalization }}
    </h3>

    <cms-unstyled-fragment [cmsContent$]="fragment | finToObservable" [showTitle]="false"></cms-unstyled-fragment>
    <fcom-link
      data-testid="read-more-saf-impact"
      class="block external-link bold-type ms-xlarge-t ms-medium-be"
      [href]="'ancillaries.saf.readMore.url' | finLocalization"
      [external]="true"
      [openInNewTab]="true"
      >{{ 'ancillaries.saf.readMore.text' | finLocalization }}</fcom-link
    >
  </div>
</fcom-modal>
